import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=45dc3857&scoped=true&"
import script from "./Markdown.vue?vue&type=script&lang=js&"
export * from "./Markdown.vue?vue&type=script&lang=js&"
import style0 from "./Markdown.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Markdown.vue?vue&type=style&index=1&id=45dc3857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc3857",
  null
  
)

export default component.exports